// extracted by mini-css-extract-plugin
export default {"root":"npKXE","timer":"Apu5v","onShader":"vrar7"};